import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { ADS_CONTACT_HREF, ADS_FAQ_HREF, ADS_HOME_HREF, ADS_SERVICES_HREF } from "@/helpers/ads";
import LoadingSpinner from "@/components/LoadingSpinner";
import AdsLogo from "./_adsLogo";

/** نسخه‌ی SSR هدر Ads؛ ابعاد دقیقا همان `_headerAds.jsx` است تا هنگام هیدریشن پرش نداشته باشیم. */
export default function HeaderAdsSSR({ pathname = "" }) {
    const clean = pathname.replace(/\/+$/, "") || "/";
    const is_root = clean === ADS_HOME_HREF.replace(/\/+$/, "") || clean === ADS_SERVICES_HREF.replace(/\/+$/, "");

    return (
        <header dir="rtl" className="relative w-full">
            <div className="fixed inset-x-0 top-0 z-40 bg-jmt-white">
                {/* mobile */}
                <div className="shadow-[0_2px_4px_rgba(0,0,0,0.1)] lg:hidden">
                    <div className="grid h-12 grid-cols-[40px_1fr_40px] items-center gap-2 px-4">
                        <div className="flex size-10 items-center justify-center text-jmt-neutral-900">
                            {!is_root && <ArrowRight size={24} aria-hidden="true" />}
                        </div>
                        <div className="flex justify-center">
                            <AdsLogo />
                        </div>
                        <span />
                    </div>
                </div>

                {/* desktop */}
                <div className="hidden lg:block">
                    <div className="w-full border-b border-jmt-neutral-100 py-4">
                        <div className="container">
                            <div className="grid w-full grid-cols-[1fr_auto_1fr] items-center gap-4">
                                <Link href="/" className="justify-self-start text-sm font-bold text-jmt-primary-800">
                                    رفتن به فروشگاه ژومنت
                                </Link>
                                <AdsLogo />
                                <div className="flex justify-end"><LoadingSpinner size={20} /></div>
                            </div>
                        </div>
                    </div>

                    <div className="border-b border-jmt-neutral-100">
                        <nav className="flex w-full items-center justify-center gap-6">
                            <span className="flex cursor-default select-none items-center gap-1 py-4 text-base leading-6 text-jmt-main">خدمات تبلیغاتی</span>
                            <Link href={ADS_FAQ_HREF} className="flex items-center gap-1 py-4 text-base leading-6 text-jmt-main">سوالات متداول</Link>
                            <Link href={ADS_CONTACT_HREF} className="flex items-center gap-1 py-4 text-base leading-6 text-jmt-main">تماس با ما</Link>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    );
}
